import { useEffect } from 'react';
import useTimeout from './useTimeout';

export default function useDebounce(
  delayedCallback: () => void,
  delay: number,
  dependencies: any[],
) {
  const { reset, clear } = useTimeout(delayedCallback, delay);

  useEffect(() => {
    reset();
  }, [...dependencies, reset]);

  useEffect(() => {
    return clear;
  }, [clear]);
}
